import { render, staticRenderFns } from "./ModalAddPatientToProgram.vue?vue&type=template&id=1e6c39bd&scoped=true"
import script from "./ModalAddPatientToProgram.vue?vue&type=script&lang=js"
export * from "./ModalAddPatientToProgram.vue?vue&type=script&lang=js"
import style0 from "./ModalAddPatientToProgram.vue?vue&type=style&index=0&id=1e6c39bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6c39bd",
  null
  
)

export default component.exports